<template>
  <div>
		<div>
			<chart :options="chartOptions"></chart>
		</div>
		<div style="padding-bottom: 50px;" v-html="result.other.criterion?.replace(/\n/ig, '<br/>')"></div>
  </div>

</template>

<script>
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';

More(Highcharts)

export default {
	components: {Chart},
	props: {
		result: Object
	},
	// watch: {
	// 	visible() {
	// 		if (this.visible) {
	// 			this.filter.type = this.type;
	// 			this.loadList();
	// 		}
	// 	}
	// },	
	data(){
		return {
			chartOptions: {
				chart: {
							polar: true,
							backgroundColor: null
				},
				title: null,
				pane: {
							size: '80%'
				},
				xAxis: {
							categories: ['躯体化', '强迫症状', '人际关系敏感', '抑郁', '焦虑', '敌对','恐怖','偏执','精神病性','其他'],
							tickmarkPlacement: 'on',
							lineWidth: 0,
				},
				yAxis: {
							gridLineInterpolation: 'polygon',
							lineWidth: 0,
							min: 0,
							// max:4,
				},
				tooltip: {
							shared: true,
							pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.2f}</b><br/>'
				},
				legend: {
							align: 'right',
							verticalAlign: 'top',
							y: 70,
							layout: 'vertical'
				},
			series: [ 	
					{
						name: '正常范围',
						data: [],
						color:'#AFAFAF',
						type: 'area',
						pointPlacement: 'on'
					},
					{
						name: '个人风险',
						data: [],
						pointPlacement: 'on',
						type: 'area',
						color:'#699ce4'
					}
			],
			credits: { enabled: false },
			exporting:null,
			},			
		}
	},
	created() {
		console.log('啥数据', this.result);
		this.chartOptions.series[0].data = this.result.other.normalArr;
		this.chartOptions.series[1].data = this.result.other.scoreArr;
	},
	methods: {}
}
</script>
